import React from 'react';

import { RMFWizard } from '@swf/first';

import FirstRoute from './FirstRoute';

const RmfRoute: React.FC = () => <FirstRoute component={RMFWizard} noCache />;

export default RmfRoute;
